module.exports = __webpack_public_path__ + "static/media/YT.4aa43a7d.png";